module.exports = __webpack_public_path__ + "static/media/17a Crossface.caafd065.jpg";